<template>
  <div>
    <div class="container">
      <div class="searchbox">
        <div class="item">
          <span>药品名称</span>
          <el-input
            placeholder="请输入"
            v-model="goods_name"
            style="width: 130px; margin-left: 8px"
            @input="search"
            clearable
          ></el-input>
        </div>
        <div class="item">
          <span>剂型类型</span>
          <el-select
            v-model="drug_type_pid"
            placeholder="请选择"
            style="width: 130px; margin-left: 8px"
            @change="search"
            clearable
          >
            <el-option
              v-for="item in dosage_form_list"
              :key="item.drug_type_pid"
              :label="item.drug_type_pid_name"
              :value="item.drug_type_pid"
            ></el-option>
          </el-select>
        </div>
        <div class="item">
          <span>药房名称</span>
          <el-select
            v-model="hospital_id"
            placeholder="请选择"
            style="width: 240px; margin-left: 8px"
            @change="search"
            multiple
            clearable
          >
            <el-option
              v-for="item in hospitalList"
              :key="item.hospital_id"
              :label="item.hospital_name"
              :value="item.hospital_id"
            ></el-option>
          </el-select>
          <!-- <myInputSerch v-model="hospital_id" @update="search" style="margin:0 10px 0 10px;"></myInputSerch> -->
        </div>
        <div class="item">
          <span>用药时间</span>
          <el-date-picker
            v-model="date"
            type="daterange"
            range-separator="~"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            style="width: 225px; margin-left: 8px"
            @change="search"
            clearable
          ></el-date-picker>
        </div>

        <div class="item">
          <span>关联单号</span>
          <el-input
            placeholder="请输入"
            v-model="order_sn"
            style="width: 130px; margin-left: 8px"
            @input="search"
            clearable
          ></el-input>
        </div>

        <div class="item flex align-center">
          <span style="margin-right: 12px">是否校正</span>
          <el-radio-group v-model="correct_bool" @change="search">
            <el-radio :label="''">全部</el-radio>
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </div>
      </div>
      <div style="margin: 12px 0 16px 0" class="flex between">
        <div>
          <el-button type="primary" @click="search" size="medium"
            >查询</el-button
          >
          <el-button plain @click="clearSearch" size="medium">重置</el-button>
        </div>
        <div>
          <el-button
            type="primary"
            @click="outData"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('496') : false
            "
            size="medium"
            >导出Excel</el-button
          >
          <el-button
            type="primary"
            @click="orderDrugs"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('507') : false
            "
            size="medium"
            >整体订单药品校正</el-button
          >
        </div>
      </div>

      <div style="border: solid 1px #c9cbd6">
        <el-table
          ref="multipleTable"
          :data="tableData"
          tooltip-effect="dark"
          style="width: 100%; min-width: 1000px"
          :header-cell-style="{ background: '#F5F5F5' }"
          @sort-change="changeOrder"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-background="rgba(0, 0, 0,0.1)"
        >
          <el-table-column prop="goods_name" label="药品名称"></el-table-column>
          <el-table-column
            prop="hospital_name"
            label="药房名称"
          ></el-table-column>
          <el-table-column
            prop="drug_type_pid_name"
            label="剂型分类"
          ></el-table-column>

          <el-table-column
            prop="item_use_level"
            label="销售量"
            sortable="custom"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.item_use_level"
                >{{ scope.row.item_use_level }}g</span
              >
            </template>
          </el-table-column>
          <el-table-column prop="correct_num" label="校正量" sortable="custom">
            <template slot-scope="scope">
              <span v-if="scope.row.correct_num"
                >{{ scope.row.correct_num }}g</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="correct_count"
            label="校正次数"
          ></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="toCorrect(scope.row)"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('481') : false
                "
                >校正编辑</el-button
              >
              <el-button
                type="text"
                @click="toDetails(scope.row)"
                :disabled="
                  module_id_array[0] ? !module_id_array.includes('481') : false
                "
              >
                详情
              </el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div style="margin-top: 20px">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="添加整体订单药品剂量校正"
      :visible.sync="dialog"
      width="800px"
      style="text-align: left"
      :close-on-click-modal="false"
      custom-class="create-order-correct"
    >
      <div style="padding: 20px">
        <div>
          <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleFormRef"
            label-width="90px"
            class="demo-ruleForm"
          >
            <el-form-item prop="correct_time" label="校正时间">
              <el-date-picker
                type="date"
                placeholder="选择日期"
                v-model="ruleForm.correct_time"
                style="width: 640px"
              ></el-date-picker>
            </el-form-item>
            <el-form-item prop="hospital_id" label="选择药房">
              <el-select
                v-model="ruleForm.hospital_id"
                placeholder="请选择"
                style="width: 640px"
              >
                <el-option
                  v-for="item in hospitalList"
                  :key="item.hospital_id"
                  :label="item.hospital_name"
                  :value="item.hospital_id"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="校正原因" prop="correct_desc">
              <el-select
                v-model="ruleForm.correct_desc"
                placeholder="请选择"
                style="width: 640px"
              >
                <el-option label="多发药物" value="多发药物"></el-option>
                <el-option label="实际未发" value="实际未发"></el-option>
                <el-option label="少发药物" value="少发药物"></el-option>
                <el-option label="错发药物" value="错发药物"></el-option>
                <el-option label="其他" value="其他"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="关联单号" prop="order_sn">
              <el-input
                v-model="ruleForm.order_sn"
                style="width: 640px"
                placeholder="请输入关联发药订单"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="校正类型"
              prop="correct_type"
              :class="ruleForm.correct_type == 2 ? ' correct-type' : ''"
            >
              <el-radio-group
                v-model="ruleForm.correct_type"
                @change="changeCorrectType"
                size="medium"
              >
                <el-radio-button :label="1">整单校正</el-radio-button>
                <el-radio-button :label="2">部分校正</el-radio-button>
              </el-radio-group>

              <el-table
                v-if="ruleForm.drug_obj.length && ruleForm.correct_type == 2"
                style="margin-top: 10px"
                tooltip-effect="dark"
                height="300"
                size="medium"
                :header-cell-style="{
                  background: '#F5F5F5',
                  height: '20px',
                  padding: '0',
                }"
                :data="ruleForm.drug_obj"
                stripe
                border
              >
                <el-table-column
                  label="药品名"
                  align="center"
                  prop="generic_name"
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.is_national_standard == 1
                        ? `${scope.row.generic_name}（新）`
                        : scope.row.generic_name
                    }}
                  </template>
                </el-table-column>
                <el-table-column
                  label="剂型"
                  align="center"
                  prop="drug_type_name"
                >
                </el-table-column>
                <el-table-column
                  label="用量"
                  align="center"
                  prop="item_use_level"
                >
                  <template slot-scope="scope">
                    {{
                      scope.row.is_national_standard == 1
                        ? scope.row.national_standard_level
                        : scope.row.item_use_level
                    }}
                  </template>
                </el-table-column>

                <el-table-column label="校正量" align="center" width="300">
                  <template slot-scope="scope">
                    <div class="flex">
                      <el-form-item
                        label=""
                        :prop="`drug_obj[${scope.$index}].sign`"
                        :rules="[
                          {
                            required: true,
                            message: '请选择',
                            trigger: 'change',
                          },
                        ]"
                      >
                        <el-select
                          v-model="scope.row.sign"
                          size="small"
                          style="width: 70px; margin-right: 10px"
                          placeholder=""
                        >
                          <el-option label="+" value="+"> </el-option>
                          <el-option label="-" value="-"> </el-option>
                        </el-select>
                      </el-form-item>
                      <el-form-item label="">
                        <!-- :prop="`drug_obj[${scope.$index}].num`"
                        :rules="[{ required: true, message: '请输入', trigger: 'change' }]" -->
                        <el-input-number
                          v-model="scope.row.num"
                          size="small"
                          :min="1"
                          :max="100"
                          :precision="0"
                          :controls="false"
                          style="width: 114px"
                        >
                        </el-input-number>
                      </el-form-item>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-form-item>

            <el-form-item
              v-if="ruleForm.correct_type == 1"
              label="校正剂数"
              prop="num"
            >
              <el-select
                v-model="ruleForm.sign"
                size="small"
                style="width: 70px; margin-right: 10px"
                placeholder=""
              >
                <el-option label="+" value="+"> </el-option>
                <el-option label="-" value="-"> </el-option>
              </el-select>
              <el-input-number
                v-model="ruleForm.num"
                size="small"
                :min="1"
                :max="100"
                :precision="0"
                :controls="false"
                style="width: 114px"
              >
              </el-input-number>
              <span>&nbsp;&nbsp; 剂</span>
            </el-form-item>

            <el-form-item
              label="图片上传"
              prop="correct_image"
              class="correct-image"
            >
              <div class="image-box">
                <UploadImg @emitImg="emitImg"></UploadImg>
                <UploadImg @emitImg="emitImg"></UploadImg>
                <UploadImg @emitImg="emitImg"></UploadImg>
              </div>
            </el-form-item>

            <el-form-item label="备注" prop="remark">
              <el-input
                v-model="ruleForm.remark"
                style="width: 640px"
                placeholder="请输入，如相关药品信息等"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div style="text-align: right; margin-top: 20px">
          <el-button
            type="primary"
            style="width: 92px"
            size="medium"
            @click="submitForm('ruleFormRef')"
            >确定</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import myInputSerch from "@/components/myInputSerch";
import UploadImg from "@/components/uploadImg/index";
import common from "@/api/common";
import dayjs from "dayjs";
export default {
  components: {
    myInputSerch,
    UploadImg,
  },
  data() {
    return {
      currentPage: 1,
      pagesize: 10,
      totalNum: 0,
      tableData: [],
      goods_name: "",
      drug_type_pid: "",
      order_sn: "",
      correct_bool: "",
      hospital_id: [],
      date: [],
      dosage_form_list: [],
      hospitalList: [],
      loading: false,
      orderby: 0,
      dialog: false,
      ruleForm: {
        correct_time: "",
        correct_desc: "",
        correct_type: "",
        order_sn: "",
        remark: "",
        hospital_id: "",
        sign: "+",
        num: undefined,
        drug_obj: [],
        correct_image: [],
      },
      rules: {
        correct_time: [
          { required: true, message: "请输入校正时间", trigger: "blur" },
        ],
        correct_desc: [
          { required: true, message: "请选择校正原因", trigger: "change" },
        ],
        correct_type: [
          { required: true, message: "请选择校正类型", trigger: "change" },
        ],
        hospital_id: [
          { required: true, message: "请选择药房", trigger: "change" },
        ],
        order_sn: [
          { required: true, message: "请输入关联单号", trigger: "blur" },
        ],
        sign: [{ required: true, message: "请选择", trigger: "change" }],
        num: [{ required: true, message: "请输入", trigger: "blur" }],
      },
    };
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  created() {
    this.initDate();
    this.getDosageList();
    this.getHospitalList();
  },
  activated() {
    this.initDate();
    this.getList();
  },
  methods: {
    initDate() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      end = dayjs(end).format("YYYY-MM-DD");
      start = dayjs(start).format("YYYY-MM-DD");
      this.date = [start, end];
    },
    // 获取订单药品
    getOrderDrug() {
      common
        .getOrderDrug({ order_sn: this.ruleForm.order_sn })
        .then((res) => {
          let { code, data } = res;
          if (code === 0) {
            this.ruleForm.drug_obj = data.map((item) => {
              item.sign = "+";
              item.num = undefined;
              return item;
            });
            console.log(this.ruleForm);
          } else {
            this.ruleForm.drug_obj = [];
            this.ruleForm.correct_type = 1;
          }
        })
        .catch((err) => {
          this.ruleForm.drug_obj = [];
          this.ruleForm.correct_type = 1;
        });
    },
    changeCorrectType(val) {
      if (val == 2) {
        if (this.ruleForm.order_sn == "") {
          this.$message.warning("请选择输入关联单号");
          this.ruleForm.correct_type = 1;
          return;
        }
        this.getOrderDrug();
      }
      this.ruleForm = Object.assign(this.ruleForm, {
        sign: "+",
        num: undefined,
        drug_obj: [],
      });
    },
    emitImg(data) {
      let { path, pic } = data;
      this.ruleForm.correct_image.push(pic);
    },
    //获取药品列表
    getList() {
      if (!this.hospital_id.length) {
        this.$message.error("请先选择药房");
        return false;
      }
      this.loading = true;
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        goods_name: this.goods_name,
        drug_type_pid: this.drug_type_pid,
        order_sn: this.order_sn,
        correct_bool: this.correct_bool,
        hospital_id: this.hospital_id.toString(),
        orderby: this.orderby,
      };
      if (this.date && this.date.length > 0) {
        data.create_time_start = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.create_time_end = dayjs(this.date[1]).format("YYYY-MM-DD");
      }
      this.axios
        .post("platform/hospital/getHospitalDrugTypepidGoodsCorrect", data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list;
            this.totalNum = res.data.total;
            this.loading = false;
          } else {
            this.loading = false;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //更改顺序
    changeOrder(value) {
      let order = value.order;
      let prop = value.prop;
      //升序
      if (order == "ascending") {
        if (prop == "item_use_level") {
          this.orderby = 1;
        } else if (prop == "correct_num") {
          this.orderby = 3;
        }
      }
      //降序
      if (order == "descending") {
        if (prop == "item_use_level") {
          this.orderby = 2;
        } else if (prop == "correct_num") {
          this.orderby = 4;
        }
      }
      if (!order) {
        this.orderby = 0;
      }
      this.getList();
    },
    //导出
    outData() {
      let loading = this.$loading();
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        goods_name: this.goods_name,
        drug_type_pid: this.drug_type_pid,
        order_sn: this.order_sn,
        correct_bool: this.correct_bool,
        hospital_id: this.hospital_id.toString(),
        orderby: this.orderby,
      };
      if (this.date && this.date.length > 0) {
        data.create_time_start = dayjs(this.date[0]).format("YYYY-MM-DD");
        data.create_time_end = dayjs(this.date[1]).format("YYYY-MM-DD");
      }

      this.axios
        .post("platform/hospital/exporHospitalDrugTypepidGoodsCorrect", data)
        .then((res) => {
          if (res.code == 0) {
            let host =
              document.location.protocol +
              "//" +
              window.location.host +
              res.data.url +
              "?correct_no=" +
              res.data.correct_no;
            location.href = host;
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    //校正编辑
    toCorrect(row) {
      let { goods_id, drug_id, hospital_id, drug_type_pid } = row;
      this.$router.push({
        path: "/home/hospital/statisticsDetails",
        query: {
          goods_id,
          drug_id,
          hospital_id,
          drug_type_pid,
          type: 1,
        },
      });
    },
    // 详情
    toDetails(row) {
      let { goods_id, drug_id, hospital_id, drug_type_pid } = row;
      this.$router.push({
        path: "/home/hospital/statisticsDetails",
        query: {
          goods_id,
          drug_id,
          hospital_id,
          drug_type_pid,
          type: 1,
          activeName: 2,
        },
      });
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //清空搜索框
    clearSearch() {
      this.goods_name = "";
      this.drug_type_pid = "";
      this.hospital_id = "";
      this.date = [];
      this.order_sn = "";
      this.correct_bool = "";
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //获取剂型
    getDosageList() {
      this.axios.post("platform/hospital/getDrugTypePidName").then((res) => {
        this.dosage_form_list = res.data.list;
      });
    },
    //药房列表
    getHospitalList() {
      let data = {
        org_type: 0,
        hospiatl_type: 0,
        page: 1,
        pageNumber: 10000,
      };
      this.axios.post("platform/hospital/getHospitaList", data).then((res) => {
        this.hospitalList = res.data.list.map((item) => {
          return {
            hospital_id: item.hospital_id,
            hospital_name: item.hospital_name,
          };
        });
      });
    },
    //订单药品校正弹窗
    orderDrugs() {
      this.ruleForm = {
        correct_time: "",
        correct_desc: "",
        correct_type: 1,
        order_sn: "",
        remark: "",
        hospital_id: "",
        sign: "+",
        num: undefined,
        drug_obj: [],
        correct_image: [],
      };
      this.$nextTick(() => {
        this.$refs["ruleFormRef"].clearValidate();
      });
      this.dialog = true;
    },
    //提交校正
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.ruleForm);
          params.correct_time = dayjs(this.ruleForm.correct_time).format(
            "YYYY-MM-DD"
          );
          if (params.correct_type == 2) {
            params.drug_obj = params.drug_obj.map((item) => {
              let { drug_id, drug_type, sign, num } = item;
              let obj = {
                drug_id,
                drug_type,
                sign,
                num,
              };
              return obj;
            });
          }
          params.correct_image = params.correct_image
            .filter((item) => item != "")
            .join(",");
          console.log(params);
          this.axios
            .post("platform/hospital/createOrderCorrect", params)
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("添加成功");
                this.dialog = false;
                this.getList();
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 0 20px 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.mydivider {
  margin: 0;
}
.dialogtable {
  width: 530px;
  margin: 0 auto 20px;
  background-color: #ffffff;
  box-sizing: border-box;
  border: solid 1px #c9cbd6;
}
.btnbox {
  text-align: left;
  margin: 20px 0;
  padding-left: 14px;
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  .item {
    margin-right: 30px;
    margin-top: 16px;
  }
}
</style>
<style lang="scss" >
.create-order-correct {
  .correct-type {
    & > .el-form-item__content {
      height: 400px;
    }
    .el-table {
      .el-form-item__content {
        height: 56px;
        .el-form-item__error {
          top: 40px;
        }
      }
    }
  }
  .correct-image {
    .el-form-item__content {
      height: 100px;
    }
    .image-box {
      display: flex;
      .cus-upload-img {
        margin-right: 10px;
      }
    }
  }
}
</style>
